// Canonical position keys used to persist user-entered ICS-203 organization
// assignments (table: ics_incident_organization_assignments). These keys are
// the contract between DICE (writes) and COMS (reads when rendering the PDF).
// Keep in sync with COMS's `src/routes/Forms/ICS_CG/forms/ics203PositionKeys.ts`.

export const ICS203_POSITION_KEYS = {
  // Incident Commander deputies / agencies (per-row of the IC table)
  ic1Deputy: 'Incident Commander Deputy',
  ic2Deputy: 'Incident Commander 2 Deputy',
  ic3Deputy: 'Incident Commander 3 Deputy',
  ic4Deputy: 'Incident Commander 4 Deputy',
  ic5Deputy: 'Incident Commander 5 Deputy',
  ic1Agency: 'Incident Commander Agency',
  ic2Agency: 'Incident Commander 2 Agency',
  ic3Agency: 'Incident Commander 3 Agency',
  ic4Agency: 'Incident Commander 4 Agency',
  ic5Agency: 'Incident Commander 5 Agency',

  // Planning section
  documentationUnitLeader: 'Documentation Unit Leader',
  demobilizationUnitLeader: 'Demobilization Unit Leader',
  technicalSpecialists: 'Technical Specialists',
  planningSectionDeputy: 'Planning Section Deputy',

  // Logistics section
  logisticSectionChief: 'Logistics Section Chief',
  logisticSectionDeputy: 'Logistics Section Deputy',
  supportBranchName: 'Support Branch',
  supportBranchDirector: 'Support Branch Director',
  supplyUnitLeader: 'Supply Unit Leader',
  facilitiesUnitLeader: 'Facilities Unit Leader',
  vesselSupportUnitLeader: 'Vessel Support Unit Leader',
  groundSupportUnitLeader: 'Ground Support Unit Leader',
  serviceBranchName: 'Service Branch',
  serviceBranchDirector: 'Service Branch Director',
  medicalUnitLeader: 'Medical Unit Leader',
  foodUnitLeader: 'Food Unit Leader',
  communicationUnitLeader: 'Communications Unit Leader',

  // Operations section
  operationSectionChief: 'Operations Section Chief',
  operationSectionDeputy: 'Operations Section Deputy',
  stagingAreaManager1: 'Staging Area Manager 1',
  stagingAreaManager2: 'Staging Area Manager 2',
  stagingAreaManager3: 'Staging Area Manager 3',
  airOperationDirector: 'Air Operations Branch Director',
  helicopterCoordinator: 'Helicopter Coordinator',

  // Intelligence / Investigations section
  intelligenceUnitLeader: 'Intelligence Section Chief',
  intelligenceDeputy: 'Intelligence Section Deputy',

  // Finance / Administration section
  financeSectionChief: 'Finance Section Chief',
  financeSectionDeputy: 'Finance Section Deputy',
  costUnitLeader: 'Cost Unit Leader',
  timeUnitLeader: 'Time Unit Leader',
  procurementUnitLeader: 'Procurement Unit Leader',
  compensationUnitLeader: 'Compensation Unit Leader',
} as const;

export type Ics203PositionKey =
  (typeof ICS203_POSITION_KEYS)[keyof typeof ICS203_POSITION_KEYS];

export const ALL_ICS203_POSITION_KEYS: readonly Ics203PositionKey[] =
  Object.values(ICS203_POSITION_KEYS);
